import { useLayoutEffect, useRef } from 'react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { projects } from '../data/projects'
import { useReducedMotion } from '../hooks/useReducedMotion'

gsap.registerPlugin(ScrollTrigger)

export function WorkRail() {
  const section = useRef<HTMLElement>(null)
  const rail = useRef<HTMLDivElement>(null)
  const progress = useRef<HTMLDivElement>(null)
  const reduced = useReducedMotion()

  useLayoutEffect(() => {
    if (reduced || !section.current || !rail.current || window.innerWidth < 900) return
    const context = gsap.context(() => {
      const travel = () => Math.max(0, rail.current!.scrollWidth - window.innerWidth + 32)
      gsap.to(rail.current, {
        x: () => -travel(),
        ease: 'none',
        scrollTrigger: {
          trigger: section.current,
          start: 'top top',
          end: () => `+=${travel() * 1.08}`,
          pin: true,
          scrub: 0.65,
          invalidateOnRefresh: true,
          onUpdate: (self) => gsap.set(progress.current, { scaleX: self.progress }),
        },
      })
    }, section)
    return () => context.revert()
  }, [reduced])

  return (
    <section className="work-section" id="work" ref={section}>
      <div className="work-heading">
        <p className="eyebrow">01 / SELECTED WORK</p>
        <h2>SELECTED WORK,<br /><em>BUILT FOR ACTION.</em></h2>
        <p className="work-instruction">SCROLL TO EXPLORE <span aria-hidden="true">→</span></p>
      </div>
      <div className="work-rail" ref={rail}>
        {projects.map((project, index) => (
          <article className="project-card" key={project.name} style={{ '--project-accent': project.accent } as React.CSSProperties}>
            <div className="project-card__meta">
              <span>{String(index + 1).padStart(2, '0')}</span>
              <span>{project.category}</span>
              <span className={project.kind === 'LIVE PROJECT' ? 'is-live' : ''}>{project.kind}</span>
            </div>
            <div className="project-browser">
              <div className="browser-bar"><i /><i /><i /><span>q1.website/{project.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}</span></div>
              <span className={`project-kind ${project.kind === 'LIVE PROJECT' ? 'is-live' : ''}`}>{project.kind}</span>
              <img src={project.desktop} alt={`${project.name} website preview`} loading={index > 1 ? 'lazy' : 'eager'} />
            </div>
            {project.mobile && <img className="project-phone" src={project.mobile} alt={`${project.name} mobile preview`} loading="lazy" />}
            <h3>{project.name}</h3>
          </article>
        ))}
      </div>
      <div className="work-progress" aria-hidden="true"><div ref={progress} /></div>
    </section>
  )
}
